import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../../generic-components/Icon';
import snackBarCheckIcon from '../../../../assets/svg/white-check-mark.svg';
import Heading from '../../../../generic-components/Heading';

interface IProps {
  connectionType: string;
}

export const SnackBar = ({ connectionType }: IProps) => {
  const { t } = useTranslation();
  return (
    <div className='absolute z-[90] top-0 left-[50%] translate-x-[-50%] py-[8px] px-[20px] rounded-[8px] bg-bw08 flex items-center'>
      <Icon src={snackBarCheckIcon} className='w-[28px] mr-[12px]' />
      <div className='flex flex-col'>
        <Heading
          title={`${t('ADD_PAYMENT_SUCCESS_HEADER', { connectionType })}`}
          className='font-metricMedium text-bw00 text-[1rem]'
        />
        <Heading
          title={`${t('ADD_PAYMENT_SUCCESS_TEXT', { connectionType })}`}
          className='font-metric text-bw00 text-[14px]'
        />
      </div>
    </div>
  );
};
